enum EntityType {
   Product = "PRODUCT",
   ProductIssue = "PRODUCT_ISSUE",
   ProductMigration = "PRODUCT_MIGRATION",
   RateSource = "RATE_SOURCE",
   Rate = "RATE",
   Customer = "CUSTOMER",
   Person = "PERSON",
   Organisation = "ORGANISATION",
   Region = "REGION",
   Account = "ACCOUNT", // Note: Keep this as a fallback, unsure if the backend has compatibility for splitting deposit/lending account entity types
   DepositAccount = "DEPOSIT_ACCOUNT",
   LendingAccount = "LENDING_ACCOUNT"
}

export default EntityType
